import ItemView from './ItemView';
import { type Item, defaultItem } from '@/utils/store';
import { addUndo } from '@/utils/undoer';

export default function ItemsView({
  items,
  onChange,
}: {
  items: Item[];
  onChange: (items: Item[]) => void;
}) {
  return (
    <>
      {[...items, defaultItem()].map((item, index) => (
        <ItemView
          key={index}
          row={index}
          item={item}
          onChange={item => {
            if (index === items.length) {
              onChange([...items, item]);
              return;
            }
            const newItems = [...items];
            newItems[index] = item;
            onChange(newItems);
          }}
          onDelete={() => {
            if (index === items.length) return;
            const ogItems = [...items];
            const newItems = [...items];
            newItems.splice(index, 1);
            onChange(newItems);

            addUndo(
              () => onChange(ogItems),
              () => onChange(newItems),
            );
          }}
          onInsertAbove={() => {
            const ogItems = [...items];
            const newItems = [...items];
            newItems.splice(index, 0, defaultItem());
            onChange(newItems);

            addUndo(
              () => onChange(ogItems),
              () => onChange(newItems),
            );
          }}
          onEnter={i => {
            if (i === 'stockNumber') {
              const elem = document.getElementById(`stockNumber-${index + 1}`);
              if (elem) {
                elem.focus();
              }
              return;
            }
            const elem = document.getElementById(`description-${index + 1}`);
            if (elem) {
              elem.focus();
            }
          }}
        />
      ))}
    </>
  );
}
